import { TranslateService } from '@ngx-translate/core';
import * as Domain from '@core/Domain';

export class DomainIit {

  static Init(translateService: TranslateService) {
const domain_LocalResourcesDefinition = new Domain.Domain_LocalResourcesDefinition(translateService);
const globalResourcesDefinition = new Domain.GlobalResourcesDefinition(translateService);
const versionInfo = new Domain.VersionInfo(translateService);
const environment = new Domain.Environment(translateService);
const defaultUserEnvironment = new Domain.DefaultUserEnvironment(translateService);
const imlementationStrategyInstance = new Domain.ImlementationStrategyInstance(translateService);
const subscription = new Domain.Subscription(translateService);
const subscriptionPlan = new Domain.SubscriptionPlan(translateService);
const application = new Domain.Application(translateService);
const user = new Domain.User(translateService);
const subscriptionLimitations = new Domain.SubscriptionLimitations(translateService);
const projectRights = new Domain.ProjectRights(translateService);
const subscriptionActivation = new Domain.SubscriptionActivation(translateService);
const subscriptionDatabaseInfo = new Domain.SubscriptionDatabaseInfo(translateService);
const userLogins = new Domain.UserLogins(translateService);
const usageActivity = new Domain.UsageActivity(translateService);
const buildServerRule = new Domain.BuildServerRule(translateService);
const implementationStrategy = new Domain.ImplementationStrategy(translateService);
const changeLogEntry = new Domain.ChangeLogEntry(translateService);
const queryHelper = new Domain.QueryHelper(translateService);
const buildActivity = new Domain.BuildActivity(translateService);
const containerList = new Domain.ContainerList(translateService);
const cronJobList = new Domain.CronJobList(translateService);
const runtimeServer = new Domain.RuntimeServer(translateService);
const runtimeServerResolutionRule = new Domain.RuntimeServerResolutionRule(translateService);
const getRuntimeServerResponse = new Domain.GetRuntimeServerResponse(translateService);
const applicationUserAction = new Domain.ApplicationUserAction(translateService);
const applicationUserExternalProfile = new Domain.ApplicationUserExternalProfile(translateService);
const applicationSetting = new Domain.ApplicationSetting(translateService);
const applicationUser = new Domain.ApplicationUser(translateService);
const applicationRole = new Domain.ApplicationRole(translateService);
const applicationOperation = new Domain.ApplicationOperation(translateService);
const applicationPermission = new Domain.ApplicationPermission(translateService);
const applicationClient = new Domain.ApplicationClient(translateService);
const applicationUserLogin = new Domain.ApplicationUserLogin(translateService);
const applicationUserClaim = new Domain.ApplicationUserClaim(translateService);
const profileSetting = new Domain.ProfileSetting(translateService);
const profile = new Domain.Profile(translateService);
const applicationLanguage = new Domain.ApplicationLanguage(translateService);
const applicationTimezoneInfo = new Domain.ApplicationTimezoneInfo(translateService);
const dateTimeFormat = new Domain.DateTimeFormat(translateService);
const applicationTheme = new Domain.ApplicationTheme(translateService);
const fileData = new Domain.FileData(translateService);
const auditEntityConfiguration = new Domain.AuditEntityConfiguration(translateService);
const auditPropertyConfiguration = new Domain.AuditPropertyConfiguration(translateService);
const auditLogEntry = new Domain.AuditLogEntry(translateService);
const auditLogEntryType = new Domain.AuditLogEntryType(translateService);
const auditLogPropertyActionType = new Domain.AuditLogPropertyActionType(translateService);
const workflowExecutionResult = new Domain.WorkflowExecutionResult(translateService);
const workflowContextBase = new Domain.WorkflowContextBase(translateService);
const workflowSchedule = new Domain.WorkflowSchedule(translateService);
 }

}
